import { AlertCircle,  Clock, Folder, Home, Star, Trash2, User, Calendar, File} from "react-feather";
import { MdOutlineBookmarks } from "react-icons/md";
import { BsPeople } from "react-icons/bs";
import { viewChatSideButton } from "./teacherDashboardLinks";


export const sideButtons = [
  {
    className: "light",
    icon: <User />,
    title: "Profile",
  },
  
  {
    className: "light",
    icon: <Calendar/>,
    title: "Paid Calendar",
  },
  {
    className: "light",
    icon: <Calendar/>,
    title: "AE Calendar",
  },
  
  {
    className: "light",
    icon: <Calendar/>,
    title: "Slots",
  },

  {
    className: "light",
    icon: <MdOutlineBookmarks />,
    title: "Course Tagging",
  },
  {
    className: "light",
    icon: <User />,
    title: "Student List",
  },
  viewChatSideButton,
  {
    className: "light",
    icon: <AlertCircle />,
    title: "Classes Not Marked",  
  },
  
  {
    className: "light",
    icon: <Folder/>,
    title: "Deduction Details",
  },
  {
    className: "light",
    icon: <Clock />,
    title: "Working Hours",
  },
  {
    className: "light",
    icon: <File />,
    title: "Leave Details",
  },
  {
    className: "light",
    icon: <File/>,
    title: "AI Class QA",
  },
  {
    className: "light",
    icon: <File/>,
    title: "L&D QA Score",
  },
  {
    className: "light",
    icon: <File/>,
    title: "Academic QA Score",
  },
  {
    className: "light",
    icon: <BsPeople/>,
    title: "Community",
  },
];

